import { Controller } from "@hotwired/stimulus"

// The election review queue's selection (docs/elekt.md, "Review workflow").
//
// Three levels, like a mail list: tick rows, tick the header to take every row on
// the page, then "select all N matching this filter" to take the whole filter.
// The last one only flips a hidden field (selection=filter): the form already
// carries the filter (q[...]), so the server - not this page - says which proposals
// that is, on the confirmation step that follows every bulk action.
export default class extends Controller {
    static targets = ["all", "row", "count", "banner", "bannerText", "selection", "selectAllButton", "clearButton", "action"]
    static values = { total: Number, page: Number }

    connect() {
        this.refresh()
    }

    toggleAll() {
        const checked = this.allTarget.checked
        this.rowTargets.forEach((row) => { row.checked = checked })
        this.selectionTarget.value = "ids"
        this.refresh()
    }

    rowChanged() {
        // Any manual change goes back to "these rows".
        this.selectionTarget.value = "ids"
        this.refresh()
    }

    selectAllMatching() {
        this.selectionTarget.value = "filter"
        this.refresh()
    }

    clear() {
        this.rowTargets.forEach((row) => { row.checked = false })
        if (this.hasAllTarget) this.allTarget.checked = false
        this.selectionTarget.value = "ids"
        this.refresh()
    }

    get selectedRows() {
        return this.rowTargets.filter((row) => row.checked)
    }

    get filterMode() {
        return this.selectionTarget.value === "filter"
    }

    refresh() {
        const selected = this.selectedRows.length
        const pageFull = this.rowTargets.length > 0 && selected === this.rowTargets.length
        if (this.hasAllTarget) {
            this.allTarget.checked = pageFull
            this.allTarget.indeterminate = selected > 0 && !pageFull
        }

        const count = this.filterMode ? this.totalValue : selected
        if (this.hasCountTarget) {
            this.countTarget.textContent = this.filterMode ? `all ${count} matching selected` : `${count} selected`
        }
        this.actionTargets.forEach((button) => { button.disabled = count === 0 })

        if (!this.hasBannerTarget) return
        const more = this.totalValue > this.rowTargets.length
        const show = pageFull && (more || this.filterMode)
        this.bannerTarget.classList.toggle("d-none", !show)
        if (!show) return

        if (this.filterMode) {
            this.bannerTextTarget.textContent = `All ${this.totalValue} proposals matching this filter are selected.`
        } else {
            this.bannerTextTarget.textContent = `All ${this.rowTargets.length} on this page are selected.`
        }
        this.selectAllButtonTarget.classList.toggle("d-none", this.filterMode)
        this.clearButtonTarget.classList.toggle("d-none", !this.filterMode)
    }
}
